export default "/images/Apulia-Transparent.png?f3964038931f0ee309043cd93dd5f3f0";